import { render } from "./AppNavItemGroup.vue?vue&type=template&id=a074d3fc"
import script from "./AppNavItemGroup.vue?vue&type=script&lang=js"
export * from "./AppNavItemGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__